import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, inject, VNode } from 'intact-vue-next';
import template from './group.vdt';
import { SELECT } from './constants';
import { useConfigContext } from '../config';
var typeDefs = {
  label: [String, Number, VNode]
};
export var OptionGroup = /*#__PURE__*/function (_Component) {
  _inheritsLoose(OptionGroup, _Component);
  function OptionGroup() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.select = inject(SELECT);
    _this.config = useConfigContext();
    return _this;
  }
  return OptionGroup;
}(Component);
OptionGroup.template = template;
OptionGroup.typeDefs = typeDefs;